import { gql } from "@apollo/client";

export const CREATE_USER_SITE = gql`
  mutation CreateUserSiteMutation($input: CreateUserSiteInput!) {
    createUserSite(input: $input) {
      ok
      error
      id
    }
  }
`;

export const USER_SITES = gql`
  query UserSitesQuery($where: UserSitesFiltersInput!) {
    userSites(where: $where) {
      results {
        id

        site {
          id
          name
        }
      }
    }
  }
`;

export const REMOVE_USER_SITE = gql`
  mutation RemoveUserSiteMutation($id: Int!) {
    removeUserSite(id: $id) {
      ok
      error
    }
  }
`;
